
import React from 'react';
import { motion } from 'framer-motion';

const QRInstructions: React.FC = () => {
  return (
    <motion.div 
      className="w-full mt-4 bg-blue-50 p-3 rounded-lg"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.8, duration: 0.5 }}
    >
      <p className="text-sm text-blue-600">
        Sử dụng mã QR này khi bạn đến tham dự sự kiện. 
        Mỗi mã QR chỉ có thể sử dụng một lần duy nhất.
      </p>
    </motion.div>
  );
};

export default QRInstructions;
